export default __webpack_public_path__ + "static/media/Inter-ExtraBold.e4a4cb71.ttf";